import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div style={{ paddingTop: 64 }}>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #0d2045, #1B3A6B, #2A5298)',
        padding: '72px 24px 60px', color: '#fff',
      }}>
        <div className="container">
          <div className="grid-2" style={{ gap: 56, alignItems: 'center' }}>

            <div className="fade-up">
              <div className="badge" style={{ background: 'rgba(240,180,41,0.2)', color: '#F0B429', border: '1.5px solid rgba(240,180,41,0.38)' }}>
                👨‍🏫 About Our Founder
              </div>
              <h1 className="serif" style={{ fontSize: 'clamp(26px, 4.5vw, 46px)', fontWeight: 800, margin: '18px 0 16px', lineHeight: 1.15 }}>
                VRK Tech Academy<br /><span style={{ color: '#F0B429' }}>Founder & Lead Trainer</span>
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.82)', fontSize: 16, lineHeight: 1.8, marginBottom: 28 }}>
                Passionate about making quality coding education accessible to every student in India and beyond —
                regardless of background or prior experience. Our founder believes every student deserves a fair shot at
                a bright IT career.
              </p>
              {[
                '5+ years of professional experience in Python & Web Development',
                'Trained 50+ students with a 95%+ satisfaction rate',
                'Project-based, practical teaching approach (not theory-heavy)',
                "Personal mentor — tracks each student's individual progress",
                'Strong community and alumni network',
              ].map(t => (
                <div key={t} className="check-row" style={{ color: 'rgba(255,255,255,0.88)', marginBottom: 10 }}>
                  <div className="check-icon" style={{ background: '#F0B429', color: '#1B3A6B' }}>✓</div>
                  <span>{t}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{
                width: 240, height: 240, borderRadius: '50%',
                background: 'linear-gradient(135deg, #F0B429, #C41E3A)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                border: '6px solid rgba(255,255,255,0.25)',
                boxShadow: '0 16px 48px rgba(0,0,0,0.3)',
              }}>
                <img src="/admin_pic.png" alt="Founder" style={{ width: 240, height: 240, borderRadius: '50%', objectFit: 'cover', border: '4px solid #fff' }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission / Vision / Approach */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div className="badge">🏫 Our Foundation</div>
            <h2 className="section-title" style={{ textAlign: 'center' }}>Why We Started VRK Tech Academy</h2>
          </div>
          <div className="grid-3">
            {[
              ['🎯', 'Our Mission', 'To make quality coding education affordable and accessible for every student after 10th and Intermediate — not just those in big cities.'],
              ['👁️', 'Our Vision', 'In Telangana and AP where every young person who wants a career in IT can get the foundational skills they need — regardless of financial background.'],
              ['💡', 'Our Approach', 'Project-based learning in small batches with personal attention. We focus on skills you can demonstrate, not just certificates.'],
            ].map(([icon, title, desc]) => (
              <div key={title} className="card" style={{ textAlign: 'center', padding: '36px 28px' }}>
                <div style={{ fontSize: 40, marginBottom: 14 }}>{icon}</div>
                <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 18, marginBottom: 10 }}>{title}</h3>
                <p style={{ color: 'var(--gray)', fontSize: 14, lineHeight: 1.7 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section-sm" style={{ background: 'var(--navy)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 16 }}>
            {[
              ['50+', 'Students Trained'],
              ['95%', 'Satisfaction Rate'],
              ['2', 'Courses Offered'],
              ['120+', 'Projects Built'],
              ['5+', 'Years Experience'],
            ].map(([num, label]) => (
              <div key={label} style={{
                textAlign: 'center', background: 'rgba(255,255,255,0.08)',
                borderRadius: 16, padding: '22px 16px',
                border: '1px solid rgba(255,255,255,0.12)',
              }}>
                <div style={{ fontSize: 32, fontWeight: 900, color: '#F0B429' }}>{num}</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', fontWeight: 600, marginTop: 4 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Trainers */}
      <section className="section" style={{ background: 'var(--cream)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <div className="badge">👥 Our Team</div>
            <h2 className="section-title" style={{ textAlign: 'center' }}>Our Trainers</h2>
            <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>
              VRK Tech Academy is growing! We're building a team of passionate, experienced instructors.
            </p>
          </div>

          <div className="grid-3">
            {[
              { role: 'Python & AI Trainer', exp: 'Lead — 5+ years', status: 'Active', emoji: '👨‍💻' },
              { role: 'Web Development Trainer', exp: 'Full-stack — 3 yrs', status: 'Active', emoji: '🧑‍💻' },
              { role: 'Data Science / ML Trainer', exp: 'Hiring Soon', status: 'Hiring', emoji: '👤' },
            ].map(({ role, exp, status, emoji }) => (
              <div key={role} className="card" style={{ textAlign: 'center', padding: '32px 24px' }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: status === 'Hiring' ? 'var(--lightgray)' : 'linear-gradient(135deg, var(--navy), var(--crimson))',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 28, margin: '0 auto 14px',
                  border: status === 'Hiring' ? '2px dashed #d1d5db' : 'none',
                }}>
                  {emoji}
                </div>
                <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 16, marginBottom: 4 }}>{role}</h3>
                <p style={{ color: 'var(--gray)', fontSize: 13, marginBottom: 10 }}>{exp}</p>
                <span style={{
                  background: status === 'Active' ? '#d1fae5' : 'var(--gold-light)',
                  color: status === 'Active' ? '#065f46' : 'var(--navy)',
                  padding: '4px 12px', borderRadius: 50, fontSize: 12, fontWeight: 700,
                }}>
                  {status === 'Active' ? '✓ Active' : '⏳ Hiring Soon'}
                </span>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: 28 }}>
            <p style={{ color: 'var(--gray)', fontSize: 15, marginBottom: 16 }}>
              Are you a Python or Web Dev expert who loves teaching?
            </p>
            <button
              onClick={() => navigate('/careers')}
              style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 15, background: 'none', border: 'none', cursor: 'pointer' }}
            >
              View Careers → Join Our Team
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}